import i18n from '@/plugins/vue-i18n'

function convertTreeToList(arr) {
  return arr.reduce((cur, item) => {
    const { items, ...rest } = item
    if (items) {
      cur = cur.concat(convertTreeToList(items))
    } else {
      cur.push(rest)
    }
    return cur
  }, [])
}

function permissionItem(title, key) {
  return {
    name: i18n.tc(title),
    key: key,
    items: [
      {
        name: i18n.tc('permissions.viewing'),
        key: key + '_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('permissions.editing'),
        key: key + '_edit',
        dependsOn: [key + '_view'],
      },
    ],
  }
}

const teamLeaderPermissions = [
  { name: i18n.tc('linksGeneratorWorkflow.listTitle'), key: 'link_generator', dependsOn: [] },
  permissionItem('advertisersCost.listTitle', 'advertiser_cost'),
  {
    name: i18n.tc('budgetPlanner.listTitle'),
    key: 'budget_planner',
    items: [
      {
        name: i18n.tc('permissions.viewing'),
        key: 'budget_planner_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('permissions.request'),
        key: 'budget_planner_request',
        dependsOn: ['budget_planner_view'],
      },
      {
        name: i18n.tc('permissions.requestApprove'),
        key: 'budget_planner_request_approve',
        dependsOn: ['budget_planner_view'],
      },
    ],
  },
  {
    name: i18n.tc('permissions.retargeting'),
    key: 'retargeting',
    items: [
      { name: i18n.tc('permissions.retargetingAttributionView'), key: 'retargeting_attribution_view', dependsOn: [] },
      { name: i18n.tc('permissions.retargetingAudienceView'), key: 'retargeting_audience_view', dependsOn: [] },
      {
        name: i18n.tc('permissions.retargetingAudienceEdit'),
        key: 'retargeting_audience_edit',
        dependsOn: ['retargeting_audience_view'],
      },
    ],
  },
  { name: i18n.tc('permissions.cpaSettingsBulkEdit'), key: 'cpa_settings_bulk_edit', dependsOn: [] },
  { name: i18n.tc('postbacks.listTitle'), key: 'postbacks', dependsOn: [] },
  {
    name: i18n.tc('permissions.logs'),
    key: 'logs',
    items: [
      { name: i18n.tc('permissions.offerLogs'), key: 'offer_log_view', dependsOn: [] },
      { name: i18n.tc('permissions.partnerLogs'), key: 'partner_log_view', dependsOn: [] },
      { name: i18n.tc('permissions.offerPartnerLogs'), key: 'offer_partner_log_view', dependsOn: [] },
      { name: i18n.tc('permissions.partnerSpendLogs'), key: 'partner_spend_log_view', dependsOn: [] },
      { name: i18n.tc('permissions.spendImportLogs'), key: 'spend_parse_log', dependsOn: [] },
      { name: i18n.tc('permissions.budgetRequestsLog'), key: 'budget_request_log_view', dependsOn: [] },
    ],
  },
]

const managerPermissions = [
  { name: i18n.tc('dashboard.listTitle'), key: 'dashboard', dependsOn: [] },
  {
    name: i18n.tc('partners.listTitle'),
    key: 'partners',
    items: [
      {
        name: i18n.tc('permissions.viewing'),
        key: 'partners_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('permissions.editing'),
        key: 'partners_edit',
        dependsOn: ['partners_view'],
      },
      {
        name: i18n.tc('permissions.managersAccess'),
        key: 'manager_access',
        dependsOn: ['partners_edit'],
      },
    ],
  },
  {
    name: i18n.tc('offerPartners.permissionTitle'),
    key: 'offer_partners',
    items: [
      {
        name: i18n.tc('offerPartners.viewOption'),
        key: 'offer_partners_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('offerPartners.editOption'),
        key: 'offer_partners_edit',
        dependsOn: ['offer_partners_view'],
      },
      { name: i18n.tc('permissions.cpaSettingsBulkEdit'), key: 'cpa_settings_bulk_edit', dependsOn: [] },
    ],
  },
  { name: i18n.tc('linksGeneratorWorkflow.listTitle'), key: 'link_generator', dependsOn: [] },
  permissionItem('partnersSpends.permissionTitle', 'partners_spend'),
  permissionItem('paymentInvoices.listTitle', 'mira_payment_invoice'),
  permissionItem('soloPaymentInvoices.listTitle', 'solo_payment_invoice'),
  {
    name: i18n.tc('budgetPlanner.listTitle'),
    key: 'budget_planner',
    items: [
      {
        name: i18n.tc('permissions.viewing'),
        key: 'budget_planner_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('permissions.request'),
        key: 'budget_planner_request',
        dependsOn: ['budget_planner_view'],
      },
      {
        name: i18n.tc('permissions.requestApprove'),
        key: 'budget_planner_request_approve',
        dependsOn: ['budget_planner_view'],
      },
    ],
  },
  { name: i18n.tc('postbacks.listTitle'), key: 'postbacks', dependsOn: [] },
  { name: i18n.tc('players.listTitle'), key: 'players', dependsOn: [] },
  permissionItem('players.playerPaymentStatus', 'cpa_payment'),
  { name: i18n.tc('landings.permissionName'), key: 'landing_view', dependsOn: [] },
  { name: i18n.tc('trafficSources.permissionName'), key: 'traffic_source_view', dependsOn: [] },
  { name: i18n.tc('clicks.listTitle'), key: 'click', dependsOn: [] },
  {
    name: i18n.tc('generalReport.listTitle'),
    key: 'general_report',
    dependsOn: [],
  },
  {
    name: i18n.tc('cpaRsPerformanceReport.listTitle'),
    key: 'cpa_rs_performance_report',
    dependsOn: [],
  },
  {
    name: i18n.tc('cohortAnalysis.listTitle'),
    key: 'cohort_analysis_view',
    dependsOn: [],
  },
  {
    name: i18n.tc('partnerReport.listTitle'),
    key: 'partner_report',
    dependsOn: [],
  },
  permissionItem('budgetPlan.listTitle', 'budget_report'),
  { name: i18n.tc('costsReport.listTitle'), key: 'cost_report', dependsOn: [] },
  { name: i18n.tc('newStreams.listTitle'), key: 'new_streams', dependsOn: [] },
  permissionItem('advertisersCost.listTitle', 'advertiser_cost'),
  {
    name: i18n.tc('permissions.retargeting'),
    key: 'retargeting',
    items: [
      { name: i18n.tc('permissions.retargetingAttributionView'), key: 'retargeting_attribution_view', dependsOn: [] },
      { name: i18n.tc('permissions.retargetingAudienceView'), key: 'retargeting_audience_view', dependsOn: [] },
      {
        name: i18n.tc('permissions.retargetingAudienceEdit'),
        key: 'retargeting_audience_edit',
        dependsOn: ['retargeting_audience_view'],
      },
    ],
  },
]

const partnerPermissions = [
  { name: i18n.tc('dashboard.listTitle'), key: 'dashboard', dependsOn: [] },
  { name: i18n.tc('offer.listTitle'), key: 'offer_view', dependsOn: [] },
  {
    name: i18n.tc('offerPartners.permissionTitle'),
    key: 'offer_partners',
    items: [
      {
        name: i18n.tc('offerPartners.viewOption'),
        key: 'offer_partners_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('offerPartners.editOption'),
        key: 'offer_partners_edit',
        dependsOn: ['offer_partners_view'],
      },
    ],
  },
  {
    name: i18n.tc('partnersSpends.permissionTitle'),
    key: 'partners_spend',
    items: [
      {
        name: i18n.tc('permissions.viewing'),
        key: 'partners_spend_view',
        dependsOn: [],
      },
      {
        name: i18n.tc('permissions.editing'),
        key: 'partners_spend_partner_edit',
        dependsOn: ['partners_spend_view'],
      },
    ],
  },
  permissionItem('paymentInvoices.listTitle', 'mira_payment_invoice'),
  permissionItem('soloPaymentInvoices.listTitle', 'solo_payment_invoice'),
  { name: i18n.tc('players.listTitle'), key: 'players', dependsOn: [] },
  { name: i18n.tc('landings.permissionName'), key: 'landing_view', dependsOn: [] },
  { name: i18n.tc('trafficSources.permissionName'), key: 'traffic_source_view', dependsOn: [] },
  { name: i18n.tc('clicks.listTitle'), key: 'click', dependsOn: [] },
  { name: i18n.tc('postbacks.listTitle'), key: 'postbacks', dependsOn: [] },
  {
    name: i18n.tc('generalReport.listTitle'),
    key: 'general_report',
    dependsOn: [],
  },
  {
    name: i18n.tc('cpaRsPerformanceReport.listTitle'),
    key: 'cpa_rs_performance_report',
    dependsOn: [],
  },
  {
    name: i18n.tc('cohortAnalysis.listTitle'),
    key: 'cohort_analysis_view',
    dependsOn: [],
  },
  permissionItem('players.playerPaymentStatus', 'cpa_payment'),
  permissionItem('advertisersCost.listTitle', 'advertiser_cost'),
]

const state = {
  permissionTree: [],
  permissionList: [],
}

const getters = {
  permissionTree: state => state.permissionTree || [],
  permissionList: state => state.permissionList || [],
}

const actions = {
  async loadPermissionTree(context, role) {
    const data =
      role === 'MANAGER'
        ? managerPermissions
        : role === 'PARTNER'
        ? partnerPermissions
        : teamLeaderPermissions
    context.commit('setPermissionTree', data)
    context.commit('setPermissionList', convertTreeToList(data))
    return { permissionTree: data }
  },
}

const mutations = {
  setPermissionTree(state, payload) {
    state.permissionTree = payload
  },
  setPermissionList(state, payload) {
    state.permissionList = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
